import { ReactNode, forwardRef } from 'react';
import Link from 'next/link';
import clsx from 'clsx';
import styles from './NavLinkButton.module.scss';

interface Props {
  children: ReactNode;
  scroll?: boolean;
  href: string;
  className?: string;
}

export const NavLinkButton = forwardRef<HTMLAnchorElement, Props>(
  ({ children, href, scroll = true, className }, ref) => (
    <Link scroll={!!scroll} ref={ref} href={href} className={clsx(styles.linkButton, className)}>
      {children}
    </Link>
  )
);

NavLinkButton.displayName = 'NavLinkButton';
